import Detail from './detail'
import RolesBox from './rolesBox'

export { Detail, RolesBox }



// WEBPACK FOOTER //
// ./src/components/usersManagement/index.js